import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { Modal } from '@wordpress/components';
import Header from './components/Header';
import CurrencyPopup from './components/CurrencyPopup';
import CurrencyList from './components/CurrencyList';
import useCurrencies from './hooks/useCurrencies';
import { NEW_CURRENCY_ARGS } from './constants';
import MultiCurrencyUpsell from './components/MultiCurrencyUpsell';

const CurrencyManager = () => {
	const [ isOpen, setOpen ] = useState( false );
	const [ popupDropdown, setPopupDropdown ] = useState( false );
	const [ isUpdatePopup, setIsUpdatePopup ] = useState( false );
	const [ newCurrency, setNewCurrency ] = useState( NEW_CURRENCY_ARGS );

	const {
		currencies,
		prevCurrencies,
		saveCurrencies,
		setCurrencies,
		coreCurrencies,
		isLoading,
		setIsLoading,
		status,
	} = useCurrencies();

	const modalOpen = ( {
		modalStatus: status,
		isUpdateModal: isUpdate,
		shouldAddDropdown: isDropdown,
	} ) => {
		setOpen( status );
		setPopupDropdown( isDropdown );
		setIsUpdatePopup( isUpdate );

		if ( ! status ) {
			setIsLoading( false );
			setNewCurrency( NEW_CURRENCY_ARGS );
		}
	};

	return (
		<div className="cmgf-wrapper">
			{ isOpen && (
				<Modal
					size="medium"
					title={
						isUpdatePopup
							? __( 'Update Currency', 'currency-manager-for-gravity-forms' )
							: __(
									'Add New Currency',
									'currency-manager-for-gravity-forms'
							  )
					}
					onRequestClose={ () =>
						modalOpen( {
							modalStatus: false,
							isUpdateModal: false,
							shouldAddDropdown: false,
						} )
					}
				>
					<CurrencyPopup
						currencies={ currencies }
						setCurrencies={ setCurrencies }
						newCurrency={ newCurrency }
						setNewCurrency={ setNewCurrency }
						setOpen={ setOpen }
						popupDropdown={ popupDropdown }
						coreCurrencies={ coreCurrencies }
						isUpdatePopup={ isUpdatePopup }
					/>
				</Modal>
			) }

			<Header
				currencies={ currencies }
				prevCurrencies={ prevCurrencies }
				saveCurrencies={ () => saveCurrencies( currencies ) }
			/>

			<div className="cmgf-container">
				{ status && 'no_currencies' !== status?.code && 'success' !== status && (
					<div className="status">{ status?.message }</div>
				) }

				{ status && 'success' === status && (
					<div className="updated">
						{ __(
							'Currencies updated successfully.',
							'currency-manager-for-gravity-forms'
						) }
					</div>
				) }
				<h1 className="cmgf-container__h1">
					{ __(
						'Currency Manager for Gravity Forms',
						'currency-manager-for-gravity-forms'
					) }
				</h1>

				<button
					className="cmgf-wrapper-button"
					onClick={ () =>
						modalOpen( {
							modalStatus: true,
							isUpdateModal: false,
							shouldAddDropdown: false,
						} )
					}
				>
					{ __( 'Add New Currency', 'currency-manager-for-gravity-forms' ) }
				</button>

				<button
					className="cmgf-wrapper-button"
					onClick={ () =>
						modalOpen( {
							modalStatus: true,
							isUpdateModal: true,
							shouldAddDropdown: true,
						} )
					}
				>
					{ __(
						'Override an Existing Currency',
						'currency-manager-for-gravity-forms'
					) }
				</button>

				<div className="cmgf-container__list">
					<CurrencyList
						currencies={ currencies }
						setCurrencies={ setCurrencies }
						modalOpen={ modalOpen }
						setNewCurrency={ setNewCurrency }
						isLoading={ isLoading }
						setIsLoading={ setIsLoading }
						status = {status}
					/>
				</div>
			</div>
		</div>
		
	);
};

export default CurrencyManager;
